<template>
    <div class="dropdown navbar-overflow">
        <button type="button" class="btn btn-link dropdown-toggle" data-toggle="dropdown"
                aria-expanded="false" :title="i18n('Action.ShowOptions')"
                @click="refreshItems">
            <i class="fa fa-2x fa-bars"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-inverse dropdown-menu-right" role="menu">
            <li v-for="item in items" :key="item.id" :title="i18n(item.title)">
                <a @click.prevent="triggerItem(item.id)">
                    <i class="fa fa-fw" :class="item.icon"></i> {{ i18n(item.title) }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script type="text/babel">
import { i18nMixin } from '../../mixins';
import { NAVBAR_OVERFLOW_ITEMS, isNavbarItemEnabled } from './navbar-overflow.helper';

export default {
    name: 'navbar-overflow',

    mixins: [i18nMixin],

    data () {
        return {
            items: []
        };
    },

    mounted () {
        $(this.$el).on('hidden.bs.dropdown', () => {
            $(this.$el).find('.dropdown-toggle').blur();
        });
    },

    methods: {
        refreshItems () {
            this.items = NAVBAR_OVERFLOW_ITEMS.filter(isNavbarItemEnabled);
        },

        triggerItem (id) {
            document.getElementById(id).click();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/modules/shared/components/navbar-overflow/navbar-overflow.component.vue